import * as React from 'react';
import classnames from '../_virtual/index.js';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const WishlistLoader = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-loader"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: classnames('wishlist-loader__skeleton', className)
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "16",
        rx: "5",
        fill: "currentColor"
    }))));
};

export { WishlistLoader as default };
//# sourceMappingURL=WishlistLoader.js.map
